import { a11yAria } from '../../../TypeScript/Utilities/AriaUtilities';
{
    var handleTriggerEvent_1 = function (navigationSearch, submitSearch, trigger) {
        var inputStyle = window.getComputedStyle(navigationSearch);
        var display = inputStyle.getPropertyValue('display');
        navigationSearch.style.display = display === 'none' ? 'flex' : 'none';
        navigationSearch.focus();
        submitSearch.classList.toggle('lg:hidden');
        trigger.setAttribute('aria-expanded', a11yAria.toggle.expanded(trigger));
        trigger.setAttribute('aria-label', a11yAria.toggle.label(trigger, trigger.dataset.exendedFalseLabel, trigger.dataset.exendedTrueLabel));
        trigger.querySelector('[data-search-open]').classList.toggle('hidden');
        trigger.querySelector('[data-search-close]').classList.toggle('hidden');
    };
    var handleSearchMechanism_1 = function (trigger) {
        var navigationSearch = document.querySelector('[data-search-input]');
        var submitSearch = document.querySelector('[data-submit-search]');
        trigger.addEventListener('click', function () { return handleTriggerEvent_1(navigationSearch, submitSearch, trigger); });
    };
    var searchButtons = Array.from(document.querySelectorAll('[data-toggle-search]'));
    if (searchButtons.length > 0) {
        searchButtons.map(function (trigger) { return handleSearchMechanism_1(trigger); });
    }
}
